<ul id="menuTools">
  <li>
    <button type="button" class="color-white " id="font-size-ajustA-" (click)="fontSizeDecrease()" aria-label="Reducir el tamaño del texto">
      <img src="./assets/icons/icon-decrease.svg" alt="Icono Reducir el tamaño del texto" aria-hidden="true">
    </button>
  </li>
  <li>
    <button type="button" class="color-white " id="font-size-ajustA"  (click)="fontSizeDefalult()" title="Tamaño del texto por defecto">
      <img src="./assets/icons/icon-default.svg" alt="Icono Tamaño del texto por defecto" aria-hidden="true">
    </button>
  </li>
  <li>
    <button type="button" lass="color-white " id="font-size-ajustA+"  (click)="fontSizeIncrease()" title="Aumentar el tamaño del texto">
      <img src="./assets/icons/icon-increase.svg" alt="Icono Aumentar el tamaño del texto" aria-hidden="true">
    </button>
  </li>
  <li>
    <button type="button" class="color-white " id="invert-contrast"  (click)="invertColors()" title="Cambiar niveles de contraste">
      <img src="./assets/icons/icon-contrast.svg" alt="Icono Cambiar niveles de contraste" aria-hidden="true">
    </button>
  </li>
</ul>
